import { Skeleton } from "../../../../../components/Skeleton";
import { SkeletonRow, SkeletonWrapper } from "./styles";

export const ReportSkeleton = () => {
  return (
    <SkeletonWrapper data-testid="report-skeleton" aria-hidden="true">
      <Skeleton variant="text" width="220px" />
      <SkeletonRow>
        <Skeleton variant="rectangular" height="88px" />
        <Skeleton variant="rectangular" height="88px" />
        <Skeleton variant="rectangular" height="88px" />
      </SkeletonRow>
      <SkeletonRow>
        <Skeleton variant="rectangular" height="88px" />
        <Skeleton variant="rectangular" height="88px" />
        <Skeleton variant="rectangular" height="88px" />
      </SkeletonRow>
    </SkeletonWrapper>
  );
};
